import { IGuestUser, IRole } from '@/shared/model/user.model';
import { v4 as uuidv4 } from 'uuid';
import { ROLE } from '@/constants';
import * as config from '@/shared/config/config';
import Vue from 'vue';
import TranslationService from '@/locale/translation.service';
import { updateLocalStorageDsConnectomeLanguage, updateLocalStorageUserLanguage } from '@/util/localStorage-util';
import { getCurrentTimeZoneOffset } from '@/shared/constants/ds-constants';

const store = config.initVueXStore(Vue);
const i18n = config.initI18N(Vue);
const translationService = new TranslationService(store, i18n);

export async function initGuestAccount() {
  const tempRole: IRole[] = [{ name: ROLE.ROLE_GUEST.toString() }];
  const tempLogin =
    'GID_' + uuidv4().toString().slice(0, 10).concat('@guest.com') ||
    'GID_' + new Date().getTime().toString().slice(0, 10).concat('@guest.com');
  const randomNumberString = (Math.floor(Math.random() * 900000) + 100000).toString() || '999999';
  const tempTimeZone = getCurrentTimeZoneOffset();
  const languageByBrowserLang = (await makeLanguageByBrowserLang()) || 'en';
  const guestAccount: IGuestUser = {
    authorities: tempRole,
    code: '',
    countryCode: '',
    deleted: 0,
    email: tempLogin,
    emailCode: randomNumberString,
    invitationCode: '',
    isRegister: true,
    langKey: languageByBrowserLang || 'en',
    lastName: 'Goover Guest User',
    login: tempLogin,
    nameConnectome: 'Warren',
    phoneNumber: '',
    purposeSet: [],
    receiveNews: 1,
    showOnboardDialog: 1,
    termOfService: 1,
    timeZone: tempTimeZone,
    isGuest: true,
  };

  return guestAccount;
}

export function checkIsGuestAccount(isOpenPopup?: boolean): boolean {
  let result = false;

  const localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;

  if (localStorageUser !== undefined && localStorageUser !== null) {
    result = localStorageUser?.isGuest;
  } else {
    result = false;
  }

  if (result === true && isOpenPopup !== undefined && isOpenPopup === true) {
    store.commit('appStore/setIsShowPopupRequiredLogin', true);
  }

  return result;
}

// export function mergeObjectsUser(obj1: any): any {
//   const result = { ...obj1 };
//
//   result.colorTheme = 'light';
//   result.langKey = obj1?.langKey || obj1?.langKey || localStorage.getItem('currentLanguage') || 'en';
//   result.isGuest = false;
//   result.authorities = obj1?.authorities || [ROLE.ROLE_USER.toString()];
//
//   return result;
// }

export function getBrowserLang(): 'en' | 'ko' {
  const lang = navigator.language || navigator.languages[0] || 'en';
  if (lang.startsWith('ko')) return 'ko';
  return 'en';
}

async function makeLanguageByBrowserLang(): Promise<string> {
  const result = getBrowserLang();
  localStorage.setItem('currentLanguage', result);
  store.commit('currentLanguage', result);
  translationService.refreshTranslation(result);
  updateLocalStorageDsConnectomeLanguage(result);
  updateLocalStorageUserLanguage(result);
  store.commit('setUserIdentity', { ...userIdentity, langKey: result });
  return result;
}

function userIdentity(): any {
  return store.getters?.account
    ? store.getters?.account
    : store.getters?.userIdentity
    ? store.getters?.userIdentity
    : JSON.parse(localStorage.getItem('localStorageUser'))
    ? JSON.parse(localStorage.getItem('localStorageUser'))
    : null;
}
